import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import bloglistBanner from "../../assets/images/bloglist-banner.webp";
import avatarImage from "../../assets/images/nick-user2.png";
import user2 from "../../assets/images/user2.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import APIService from "../../utils/APIService";

const BlogList = () => {
  const navigate = useNavigate();
  const [blogsList, setBlogsList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(1);
  const [latestBlog, setLatestBlog] = useState(null);

  useEffect(() => {
    fetchBlogList(1);
  }, []);

  const fetchBlogList = async (page) => {
    if (isLoading) return;

    try {
      setLoading(true);
      const url = `/blogs?page=${page}&limit=10&status=published`;
      const response = await APIService.get(url);
      const blogsData = response.blogs;
      if (page == 1) {
        if (blogsData.length) {
          setLatestBlog(blogsData[0]);
          delete blogsData[0];
        }
        setBlogsList(blogsData);
      } else {
        setBlogsList((prevBlogs) => [...prevBlogs, ...blogsData]);
      }
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setHasMore(response?.currentPage < response?.totalPages);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (currentPage < totalPages) {
      fetchBlogList(currentPage + 1);
    }
  };

  const viewBlogPost = (slug) => {
    navigate(`/blog/${slug}`);
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  return (
    <div className="wrapper">
      <Header isBackEnable={false} />
      <main className="main-curve-top">
      <div className="happy-left">&nbsp;</div>
      <div className="happy-right">&nbsp;</div>
        <section className="join-sec text-center">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="bloglist-banner content-block">
                  <h1 className="title h1">
                    Innovate & Inspire: Your Daily Dose of Ideas
                  </h1>
                  <div className="blog-banner">
                    <img
                      src={latestBlog?.image}
                      alt={latestBlog?.title}
                      className="bloglistBanner"
                    />
                    <div className="blog-banner-content">
                      <a href="#" className="technology-btn">
                        {latestBlog?.categoryId.name}
                      </a>
                      <h2 
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        viewBlogPost(latestBlog.slug);
                      }
                      }>
                        {latestBlog?.title}
                      </h2>
                      <div className="user-content">
                        <div className="userName">
                          <img
                            src={latestBlog?.authorImage || avatarImage}
                            alt={latestBlog?.authorName}
                            className="popularPost"
                          />
                          <p>{latestBlog?.authorName}</p>
                        </div>
                        <p>{formatDate(latestBlog?.createdDate)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bloglist-sec innovate-sec">
          <div className="container">
            <div className="row">
              {blogsList.map((post) => (
                <div
                  key={post._id}
                  className="col-lg-4 col-md-6 col-sm-6 col-xs-12"
                >
                  <div className="innovate-box">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="innovatImg"
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        viewBlogPost(post.slug);
                      }
                      }
                    />
                    <div className="innovate-content">
                      <a href="">{post.categoryId?.name}</a>
                      <p className="card-title" style={{cursor: 'pointer'}} onClick={() => {
                        viewBlogPost(post.slug);
                      }
                      }>{post.title}</p>
                      <div className="user-content">
                        <div className="userName">
                          <img
                            src={post.authorImage || avatarImage}
                            alt={post.authorName}
                            className="popularPost"
                          />
                          <p>{post.authorName}</p>
                        </div>
                        <p>{formatDate(post.createdDate)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {hasMore && (
              <button
                className="load-more-btn"
                onClick={handleLoadMore}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Load More"}
              </button>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogList;
